import DistributionMain from './components/Main'
import Received from './components/Received'
import Queue from './components/Queue'

export default () => ({
  path: 'distributions',
  children: [DistributionMain, Received, Queue],
})
